import { Link } from 'react-router-dom';

export function LandingPage() {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem' }}>Codenteam Hub</h1>
      <p className="muted" style={{ marginBottom: '2rem', maxWidth: 400, marginLeft: 'auto', marginRight: 'auto' }}>
        Self-hosted workspace for your team. Manage services, users, and domains, all in one place.
      </p>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/register" className="btn-primary">Get started</Link>
        <Link to="/login" className="btn-ghost">Sign in</Link>
      </div>
    </div>
  );
}
